import { useState, useRef } from 'react';
import VBTextarea from '@vb-js-commons/new/vbTextarea';
import Modal from 'react-bootstrap/Modal';
import { createSimpleBidNew, selectWinningBidNew } from '../../api/services/ad';

const AdPlaceBidSection = ({ toggle_loading, scrollCallback }) => {
    const [ad, setAd] = useState(Window.react_data.ad);
    const [visiblePlaceBidModal, setVisiblePlaceBidModal] = useState(false);
    const [visibleShowBidsModal, setVisibleShowBidsModal] = useState(window.location.toString().includes("#show_bids"));
    const [openBids, setOpenBids] = useState([]);
    const [tempFiles, setTempFiles] = useState([]);
    const [bidText, setBidText] = useState("");

    //Helpers
    const handleUploadFiles = (e) => {
        const files = Array.from(e.target.files);
        setTempFiles(prev => [...prev, ...files]);
    };

    //   Api's
    const placeBid = async () => {
        setVisiblePlaceBidModal(false);
        toggle_loading();
        const response = await createSimpleBidNew(bidText, tempFiles, ad.id);
        if (response.ok) {
            window.location.reload();
        } else {
            console.error("Error creating bid");
        }
    };

    const selectWinningBid = async (bidId) => {
        toggle_loading();
        const response = await selectWinningBidNew(bidId)
        if (response.ok) {
            window.location.reload();
        } else {
            console.error("Error selecting bid");
        }
    }

    // Render functions

    const renderAdDetailsStateBar = () => {
        const isOwner = Window.user_data.loggedInUserID === ad.ad_user;
        const isWinner = ad.winning_bid_user === Window.user_data.loggedInUserID;
        const hasBidded = ad.current_user_has_bidded;
        const isAdmin = Window.user_data.isAdmin;

        let icon = "img/icons/icon-center.svg";
        let color = "success-500";
        let text = "";
        let extra = null;

        if (ad.state_name === "WAITING_FOR_REVIEW") {
            color = "warning-500";
            text = "Din virkesannons granskas av Treebula";

        } else if (["AUCTION_READY", "PENDING_RESPONSE"].includes(ad.state_name)) {
            icon = "img/icons/check-circle.svg";

            if (ad.auction_in_future) {
                text = `${isOwner ? "Din virkesannons" : "Den här virkesannonsen"} öppnas för anbud ${ad.start_time}`;
            } else if (ad.auction_is_live) {
                text = `${isOwner ? "Din virkesannons" : "Den här virkesannonsen"} är öppen för anbud`;
            } else if (ad.auction_is_over) {
                if (hasBidded) {
                    text = "Auktionen är avslutad, säljaren väljer köpare";
                } else if (isOwner && ad.bids_visible.length !== 0) {
                    text = "Klicka på knappen nedan för att se dina anbud och välja köpare";
                } else {
                    text = "Denna affär är avslutad:";
                }
            }

        } else if (ad.state_name === "NO_BID_SELECTED") {
            icon = "img/icons/Warning.svg";
            color = "warning-500";
            text = "Säljaren valde att avvakta och valde inget anbud";

        } else if (ad.state_name === "WINNER_SELECTED") {
            icon = "img/icons/check-circle.svg";
            text = "Denna affär är avslutad";

            if (isOwner) {
                text = "Du har valt köpare - Köparen kommer att kontakta dig för fortsatt dialog, nästa steg och kontraktskrivning";
            } else if (isWinner) {
                text = "Du har blivit vald som köpare - kontakta skogsägaren för fortsatt dialog, nästa steg och kontraktskrivning";
            } else if (hasBidded && !isWinner) {
                icon = "img/icons/XCircle.svg";
                color = "warning-500";
                text = "Du har tyvärr inte valts som köpare";
            }

        } else if (ad.state_name === "CONTRACT_CREATED") {
            icon = "img/icons/check-circle.svg";
            text = "Treebula granskar virkesaffären";

            if (ad.signing_method === ad.SIGNING_ON_PAPER) {
                if (isWinner || isOwner) {
                    text = "Affären signeras på papper.";
                    extra = (
                        <a className='text-decoration-underline fw-bold me-3' href={ad.contractPdf_URL}>
                            Ladda ned kontraktet
                        </a>
                    );
                } else if (hasBidded) {
                    icon = "img/icons/icon-center.svg";
                    color = "warning-500";
                    text = "Du valdes tyvärr inte som köpare";
                }
            } else if (ad.contract !== "SIGNED") {
                text = "Treebula hanterar signering av kontrakt";
            } else if (isWinner || isOwner) {
                text = "Affären är avslutad.";
                extra = (
                    <a className='text-decoration-underline fw-bold me-3' href={ad.contractPdf_URL}>
                        Ladda ned kontraktet.
                    </a>
                );
            }

        } else if (ad.state_name === "DRAFT" && ad.ad_isFullService) {
            color = "warning-500";
            text = "Treebula arbetar med att ta fram din annons";

        } else if (ad.state_name === "CREATED" && isOwner) {
            text = "Du granskar din annons";

        } else if (ad.state_name === "DRAFT" && isAdmin) {
            color = "warning-500";
            text = "Annonsen är under bearbetning.";

        } else if (ad.state_name === "KREDITED") {
            color = "warning-500";
            text = "Affären blev inte av";

        } else if (isAdmin) {
            icon = "img/icons/Warning.svg";
            text = `Annonsen är ${ad.state_name === "INACTIVE" ? "inaktiv." : "ej redo för auktion."}`;
        } else {
            return null;
        }

        return (
            <>
                {!Window.react_data.trustedBuyer && (
                    <p className='mt-2'>
                        Eftersom du inte är ansluten köpare, måste du kontakta oss på{" "}
                        <a className="text-decoration-underline fw-bold" style={{ cursor: 'pointer' }} href="mailto:info@treebula.se">
                            info@treebula.se
                        </a>{" "}
                        för att se all information.
                    </p>
                )}

                {text && (
                    <div className="d-flex flex-row justify-content-start align-items-center">
                        <img
                            src={`${Window.static_path}${icon}`}
                            className={`rounded-circle p-1 bg-${color}`}
                            height="32px"
                            width="32px"
                            alt="Status Icon"
                        />
                        <p className="ms-2 n-fs-5 fw-medium mb-0">{text}</p>
                    </div>
                )}
                {extra && (<div>{extra}<hr className="bg-neutral-charcoal" /></div>)}
            </>
        );
    };

    const renderAdsDetailsCTA = () => {
        const isOwner = Window.user_data.loggedInUserID === ad.ad_user;
        const isAdmin = Window.user_data.isAdmin;
        const isLive = ad.auction_is_live;
        const isOver = ad.auction_is_over;
        const hasBids = ad.bids_visible.length !== 0;
        const isARorPR = ad.state_name === 'AUCTION_READY' || ad.state_name === "PENDING_RESPONSE";
        const hasUserBid = ad.current_user_has_bidded || ad.child_account_did_bid;

        const renderBidButton = () => (
            <button className="n-btn btn-charcoal text-nowrap w-100" style={{ minWidth: '100px' }} onClick={() => setVisibleShowBidsModal(true)}>
                Se dina anbud
                <span>
                    <img className="ms-2 primary-core-filter" style={{ width: "16px", height: "16px" }} src={`${Window.static_path}img/icons/arrow-black.svg`} />
                </span>
            </button>
        );

        if (!isOwner && isLive) {
            return (
                <div className="d-flex flex-column align-items-center">
                    <hr className="w-100" />
                    <button className="n-btn btn-forest-green text-nowrap w-100" style={{ minWidth: '100px' }} onClick={() => setVisiblePlaceBidModal(true)}>
                        Lämna anbud via formulär
                    </button>
                    <p className="text-center n-fs-7 my-2">eller</p>
                    <a className="n-btn btn-forest-green btn-outline text-nowrap w-100" style={{ minWidth: '100px' }} href={`mailto:anbud@treebula.se?subject=Anbud på annons #${ad.id}`}>
                        Lämna anbud via mail
                    </a>
                    <hr className="w-100" />

                    <div className="bg-neutral-stone-300 p-2" style={{ borderRadius: "8px" }}>
                        <p className="mt-2">
                            Du kan även maila ditt anbud till <a className="text-decoration-underline fw-bold" href={`mailto:anbud@treebula.se?subject=Anbud på annons #${ad.id}`}>anbud@treebula.se</a> eller ringa oss på <a className="text-decoration-underline fw-bold" href="tel:00468339944">08-33 99 44</a>.
                        </p>
                        <p>Ange annonsnummer #{ad.id}.</p>
                    </div>

                    {(hasUserBid || isAdmin) && (
                        <>
                            <hr className="w-100" />
                            {renderBidButton()}
                        </>
                    )}

                    <hr className="w-100" />
                </div>
            );
        }

        if (isOwner && isARorPR && isOver && hasBids) {
            return (
                <div className="d-flex flex-column align-items-center">
                    <hr className="w-100" />
                    <button className="n-btn btn-forest-green text-nowrap w-100 mb-3" style={{ minWidth: '100px' }} onClick={() => setVisibleShowBidsModal(true)}>
                        Välj köpare
                        <span>
                            <img className="ms-2 white-filter" style={{ width: "16px", height: "16px" }} src={`${Window.static_path}img/icons/arrow-black.svg`} />
                        </span>
                    </button>
                </div>
            );
        }

        if (isOwner && isARorPR && isOver && !hasBids) {
            return (
                <div className="d-flex align-items-start justify-content-center">
                    <p className="text-center mb-0 subtitle fw-bold">Treebula kontaktar dig gällande dina anbud</p>
                </div>
            );
        }

        if (isAdmin || hasUserBid || (isOwner && hasBids)) {
            return (
                <div className="col-12 d-flex flex-column align-items-center">
                    <hr className="w-100" />
                    {renderBidButton()}
                    <hr className="w-100" />
                </div>
            );
        }

        return null;
    }

    const isNotOwner = ad.ad_user !== Window.user_data.loggedInUserID;
    const isTrustedBuyer = Window.react_data.trustedBuyer;
    return (
        <div className='mb-4 shadow p-3 d-flex flex-column justify-content-center bg-neutral-cloud' style={{ position: 'sticky', top: '24px', zIndex: 100, borderRadius: '12px' }}>
            {renderAdDetailsStateBar()}
            {renderAdsDetailsCTA()}
            {ad.auction_in_future && <div className='text-center fw-medium n-fs-6'>
                Startdatum: {ad.start_time}
            </div>}
            {ad.auction_is_live && <div className='text-center align-items-center'>
                <div className='fw-medium n-fs-6'>
                    {ad.days_left <= 1
                        ? `Timmar kvar: ${ad.hours_left}`
                        : `Dagar kvar: ${ad.days_left}`}
                </div>

                {ad.state_name !== "CREATED" && isNotOwner && <hr />}

                {isNotOwner && isTrustedBuyer && (
                    <div className='col-12 mt-3'>
                        <a
                            className="fw-medium n-fs-7 me-3"
                            style={{ cursor: 'pointer' }}
                            href={`/contact-seller/?ad_id=${ad.id}`}
                        >
                            Fråga säljaren
                        </a>

                        {ad.attachments && (
                            <a
                                className="fw-medium n-fs-7 ms-3"
                                style={{ cursor: 'pointer' }}
                                onClick={()=>(scrollCallback())}
                            >
                                Se viktiga bilagor
                            </a>
                        )}
                    </div>
                )}
            </div>}
            {ad.state_name === 'WAITING_FOR_REVIEW' && <p className='text-center mb-0 n-fs-7 lh-sm fw-bold mb-3'>
                Just nu tittar våra specialister på din annons och kommer att godkänna annonsen eller kontakta dig så snabbt som möjligt.
            </p>}
            <Modal show={visiblePlaceBidModal} onHide={() => setVisiblePlaceBidModal(false)} size="lg" contentClassName="bg-neutral-cloud-300" style={{ zIndex: 1110 }} centered>
                <Modal.Header className="align-items-start border-0" closeButton>
                    <div>
                        <p className="n-fs-5 fw-medium mb-1">Ange anbud</p>
                        <p className="n-fs-7 neutral-pebble">Lägg till text eller ladda upp bilagor</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-flex">
                        <div className="row">
                            <div className="col-12">
                                <VBTextarea height="128px" onChange={(txt) => { setBidText(txt) }}
                                    placeholder="Lägg till text"
                                    label={<p className="pb-2 fw-medium n-fs-7">Ange anbudet i textformat här:</p>} />
                                <hr />
                                <div className="w-100">
                                    <p className='fw-medium n-fs-7 mb-1'>Ladda upp anbudsbilagor</p>
                                    <p className="n-fs-7 neutral-pebble">Ladda upp bilagor som du vill ha med i anbudet exempelvis prislistor.</p>
                                    {tempFiles.map((file) => {
                                        return <a className="bg-neutral-charcoal p-1 me-1 white rounded-3 n-fs-8 d-inline-block">
                                            {file.name}
                                            <img
                                                src={Window.static_path + 'img/icons/X.svg'}
                                                className='white-filter'
                                                role='button'
                                                width='16px'
                                                height='16px'
                                                onClick={() => {
                                                    tempFiles.splice(tempFiles.indexOf(file), 1);
                                                    setTempFiles(tempFiles);
                                                }}
                                            />
                                        </a>
                                    })}
                                </div>
                                <label className="n-btn btn-forest-green btn-sm mt-3"> <img className={`me-2`} style={{ width: "18px", height: "18px" }} src={Window.static_path + "img/icons/icon-left.svg"} />Välj filer
                                    <input onChange={handleUploadFiles} type="file" multiple style={{ display: "none" }} />
                                </label>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 justify-content-end">
                    <p className="mt-2 mb-2">Treebula tar ut en avgift på 3% på virkesvärdet (bruttovärdet) på affären av dig som köpare ifall du blir vald</p>
                    <button className="n-btn btn-forest-green btn-ghost mt-2" onClick={() => setVisiblePlaceBidModal(false)}>Avbryt</button>
                    <button className="n-btn btn-forest-green ms-2 mt-2" onClick={() => { placeBid(); }}>Ja, Skicka anbud<span><img className={`ms-2 white-filter`} style={{ width: "16px", height: "16px" }} src={Window.static_path + "img/icons/arrow-black.svg"} /></span></button>
                </Modal.Footer>

            </Modal>
            <Modal show={visibleShowBidsModal} onHide={() => setVisibleShowBidsModal(false)} size="lg" contentClassName="bg-neutral-cloud-300" style={{ zIndex: 1110 }} centered>
                <Modal.Header className="align-items-start border-0" closeButton>
                    <div>
                        <p className="n-fs-5 fw-medium mb-1">Anbud på annons #{Window.react_data.ad.id}</p>
                        <p className="n-fs-7 neutral-pebble">Se anbud</p>
                    </div>
                </Modal.Header>
                <Modal.Body className="py-0">
                    <div className="container-flex">
                        <div className="row">
                            {ad.bids_data.map((itm) => {
                                return <div> <div className={`col-12 p-3 rounded-1 mb-2 bg-${Window.react_data.ad.winning_bid_id === itm.id ? "primary-core-100" : "white"}`}>
                                    <div className='d-flex justify-content-between'>
                                        <p
                                            className="n-fs-6 fw-medium"
                                            style={{ "cursor": "pointer" }}

                                        >#{itm.id} - {itm.bid_user_name} {Window.react_data.ad.winning_bid_id === itm.id ? " - Vald köpare" : null}</p>
                                        <img src={`${Window.static_path}img/icons/dropdown-arrow.svg`} className={`max-h-25 d-flex-inline neutral-charcoal-filter`} style={{ transform: openBids.includes(itm.id) ? 'rotate(180deg)' : '', transition: 'transform 150ms ease' }} onClick={() => {
                                            if (openBids.includes(itm.id)) {
                                                setOpenBids(openBids.filter((id) => id !== itm.id));
                                            } else {
                                                setOpenBids([...openBids, itm.id]);
                                            }
                                        }} />
                                    </div>
                                    <div className={openBids.indexOf(itm.id) !== -1 ? "d-block" : "d-none"}>
                                        <div className="w-100">
                                            {itm.other_fields.map((f) => {
                                                return <p className="mw-100 text-break n-fs-7 fw-medium">
                                                    <span>{f.label}</span>: {f.value}
                                                </p>
                                            })}
                                        </div>
                                        <p className="n-fs-7 pt-2 mb-1 fw-medium">Kommentar</p>
                                        <p className="mw-100 text-break n-fs-7 neutral-pebble" style={{ whiteSpace: "pre-line" }}>{itm.comments}</p>
                                        {itm.attachments.length > 0 ? <p className="fw-medium pt-2 mb-1">Bilagor</p> : null}
                                        <div className="w-100">
                                            {itm.attachments.map((attch) => {
                                                return <a className="bg-neutral-charcoal p-1 me-1 white rounded-2 n-fs-8 d-inline-block" href={attch.url} target="_blank">{attch.file_name}</a>
                                            })}
                                        </div>
                                        {Window.react_data.ad.winning_bid_id === null && Window.react_data.ad.auction_is_over && ad.ad_user === Window.user_data.loggedInUserID ? <div className="w-100 d-flex justify-content-end">
                                            <button className="n-btn btn-forest-green btn-sm mt-1" onClick={() => { selectWinningBid(itm.id) }}>Välj denna köpare</button>
                                        </div> : null}
                                        {Window.react_data.ad.winning_bid_id === itm.id ? <div className="w-100 d-flex justify-content-end">
                                            <p className="n-btn btn-forest-green btn-sm mt-1">Vald som vinnare</p>
                                        </div> : null}
                                    </div>
                                </div>
                                    <hr />
                                </div>
                            })}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 justify-content-end">
                    <button className="n-btn btn-forest-green btn-sm mt-2" onClick={() => { setVisibleShowBidsModal(false) }}>Stäng</button>
                </Modal.Footer>

            </Modal>
        </div>
    );

}
export default AdPlaceBidSection;